<template>
  <div class="container">
    <div id="course-manager">
      <h2 class="text-center mt-5 mb-3">Course Manager</h2>
      <router-link
        class="btn btn-outline-primary btn-block mb-3"
        to="/add_course"
      >
        Add New
      </router-link>
      <ul class="list-group">
        <li class="list-group-item active">Your Courses</li>
        <router-link
          :to="`/course/${course.id}`"
          v-for="course in userCourses"
          :key="course.id"
          class="list-group-item"
        >
          {{ course.name }}
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import db from '@/components/firebaseInit'

export default {
  name: 'CourseManager',
  data() {
    return { userCourses: [] }
  },
  methods: {
    fetchCourses() {
      db.collection('courses')
        .where('creatorUid', '==', localStorage.getItem('uid'))
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.userCourses.push({ id: doc.id, ...doc.data() })
          })
        })
    }
  },
  created() {
    this.fetchCourses()
  }
}
</script>

<style lang="scss" scoped></style>
